import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/helper/util.service';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import { AnalyticsService } from '../../analytics/analytics.service';
import _ from 'lodash';
import { DataProductsService } from '../data-products.service';
import { AuthService } from '@auth0/auth0-angular';
import { MatDialog } from '@angular/material/dialog';
import { RequestAccessDialogComponent } from 'src/app/shared/request-access-dialog/request-access-dialog.component';
import { ManageRequestsService } from '../../manage-requests/manage-requests.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss'
})
export class ProductsComponent {
  isUserLoggedIn: boolean;
  moduleByteMap: { [key: string]: any };
  userId: any;
  capabilitiesModuleRecords: any[];
  capabilitiesModule: any;
  capabilitiesData: any;
  getCapabilitiesModules: any;
  totalResultCount: any;
  allCapabilitiesModulesHeaders: any;
  errMsg: any;
  showErrorMessageWithPopup: any;
  successMessage: any;
  searchText: any;
  currentPage: any =  1;
  getinsightsModules: any;
  allInsightsModulesHeaders: any;
  allProdcuts: any[];
  sortBy: any='order';
  sortType: any='asc';
  subscriptionMsg =
    'Please contact DMINT Administrator to get subscription of the same';
  
  closeSign: string;
  companyName: any;
  userName: string;
  companyId: any;
  headerId: any = '11';
  bussinessProductLine: any;
  stepOneDetails: any;
  
  constructor(private router: Router,
      private homePageService: HomePageService,
        private spinnerService: NgxSpinnerService,
        private utilService: UtilService,
        private analyticService: AnalyticsService,
        private dataProductService: DataProductsService,
        private auth: AuthService,
        private dialog: MatDialog,
        private manageRequestService: ManageRequestsService
  ) {}
  redirectToEmail() {
    let email = 'platform@dacoval.com';
    const mailtoLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}`;
    window.open(mailtoLink, '_blank');
  }
  ngOnInit() {
    //Acutal Code starts
    this.utilService.getHeaderId.subscribe((res:any) => this.headerId = res || this.headerId);
    this.userDetails();
    this.isUserLoggedIn = localStorage.getItem('id') != 'undefined' 
                          && localStorage.getItem('id') != undefined ? true: false;

    this.utilService.moduleBytes.subscribe((mod) => {
      this.moduleByteMap = mod as Object;
    });

      this.utilService.getUserId.subscribe((userId: any) => {
          this.userId = userId;
    
          this.isUserLoggedIn =  this.utilService.isUserLoggedIn();
    
          // form header api call
          this.getOnHeader();
      });
      
      this.utilService.SharingDataPopUpMessage.subscribe((res: any) => {
            this.spinnerService.hide();
            this.errMsg = res;
          });
      this.utilService.getPopupStatus.subscribe((res: any) => {
            this.spinnerService.hide();

            if (this.errMsg !== null) {
              this.showErrorMessageWithPopup = res;
            }
      });

  }

  userDetails(){
    this.userName = localStorage.getItem('userName');
    this.utilService.companyName.subscribe((res:any) => this.companyName = res);
    this.utilService.companyId.subscribe((res:any) => this.companyId = res);
  }
  loadedItemsCount = 8
 
  
  //// Product ends

  searchTerm = signal('')
  
  getOnHeader(){
    this.homePageService.onHeader(this.userId).subscribe((res) => {
            this.spinnerService.hide();
            this.capabilitiesModule = res;
            
            if (this.capabilitiesModule.message === 'OK') {
              this.capabilitiesData = this.capabilitiesModule.result;
              this.capabilitiesModuleRecords = [...this.capabilitiesData];
              for (let modulerecord of this.capabilitiesModuleRecords) {
                if (modulerecord.headerName == 'Data Products') {
                  this.getCapabilitiesModules = modulerecord.modules;  
                  this.totalResultCount = this.getCapabilitiesModules?.length    
                  this.allCapabilitiesModulesHeaders=_.cloneDeep(modulerecord.modules);        
                  this.getAllAnalyticsModules(true)

                }
              }
            }
    });
  }
  getAllAnalyticsModules(flag=false) {
        this.fetchProducts(flag) 
  }
  fetchProducts(flag:any){
      let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
  
      let payload: any = {
        "userId":userId,
        "headerId": this.headerId,
        "searchText": null,
        "categoryIds":  null,
        "regionIds":  null,
        "businessLineIds":  null,
        "functionIds":  null,
        "productLineIds":  null,
        "sortBy": this.sortBy,
        "sortType": this.sortType,
        "limit": 500,
        "page": this.currentPage
      }
      this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
        {
          next: (res: any) => {
            this.spinnerService.hide();
            this.getinsightsModules = res.result
            this.totalResultCount=res.totalCount;
            if (this.getinsightsModules?.length > 0 ) {
              this.getinsightsModules.forEach((ele: any) => {
                let index = this.allCapabilitiesModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                if (index > -1) {
                  ele.subscription = this.allCapabilitiesModulesHeaders[index]['subscription'];
                  ele.moduleLink = this.allCapabilitiesModulesHeaders[index]['moduleLink'];
               }
              })
              if (flag) {
                this.allProdcuts = []
                this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
                if(this.userId && this.isUserLoggedIn)this.getTotalReportsCount();
              }
            } 
          },
          error: (err) => {
            this.spinnerService.hide()
            this.utilService.SharingDataTextMessage.subscribe((res: any) => {
              this.errMsg = res
            })
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
          }
        }
      )
  }
  getTotalReportsCount(){
     let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
      let headerId = this.headerId;
      this.dataProductService.getTotalReports(userId, headerId).subscribe((res: any) => {
        if(res){
          let result = res.result;
          if (this.getinsightsModules?.length > 0 ) {
              this.getinsightsModules.forEach((ele: any) => {
                let index = result?.findIndex((item: any) => item.moduleId == ele.moduleId)
                if (index > -1) {
                  ele.totalReportCount = result[index]['totalRequests'];
               }
            })
          }
        }
      });
  }
  onSignIn() {
    this.utilService.onSignIn();
  }
 

onAccessPending() { 
  this.errMsg = `Please contact <a 
    href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
    target='_blank' 
    class='admin-email-link'>
    DMINT Administrator
  </a> to get access for the same`
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
}
onSubscribe() { 
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
}
 onPairingApicall(moduleLink: any) {
    this.spinnerService.hide();
    const token = localStorage.getItem('token');
    window.open(`${moduleLink}?token=${token}`, '_blank');
  }
  viewDetails(module: any) {
   this.router.navigate(
    ['/data-products/details', module.moduleId || module.id]
  );
}
  onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }




  //////
  onRequestAccessClick(module: any) {
   this.getStepOneDetails(module);
  }

  getStepOneDetails(module: any){
    this.manageRequestService.getDataForSteps(module.moduleId).subscribe((res: any) => {
          if(res){
            this.stepOneDetails = res.result;
            this.callRequestPopup(module,this.stepOneDetails)
        }
    });
  }
  callRequestPopup(module:any,stepDetails:any){
     const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
      width: '800px',
      maxWidth: '90vw',
      data: {
        module:module,
        stepDetails:stepDetails,
        title: `Request access to ${module.moduleName}`,
        panelClass: 'request-access-dialog',
        disableClose: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle business-specific data in parent component
        const apiPayload = {
          submittedByUserId: this.userId,
          companyId: this.companyId,
          headerId: this.headerId,
          moduleId: module?.moduleId,
          isModuleAttached: result?.isModuleAttached,
          userGroups: result?.userGroups
        };
   //    Submit to API
        this.manageRequestService.createAccessRequest(apiPayload).subscribe({
          next: (response:any) => {
            if(response.code == 200){
              this.successMessage = response?.result;
              setTimeout(() => { this.successMessage = ''; }, 5000);
              this.getOnHeader();
            }
          },
          error: (error) => {
            this.errMsg = 'Failed to submit access request. Please try again.';
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
          }
        });
      }
    });
    
  }
}